import { Content } from 'antd/es/layout/layout'
import { Spin } from 'antd'
import Breadcrumbs from 'components/Breadcrumbs'
import DashboardGame from 'components/Dashboard/DashboardGame'
import QuickLinks from 'components/Dashboard/QuickLinks'
import useFetchData from 'hooks/useFetchData'
import icons from 'utils/icons'

const DashboardPlayer = () => {
  // Fetch recent and upcoming games for this player
  const { data: dashboardData, isLoading: loadingDashboard } = useFetchData('/admin/dashboardPlayer');

  return (
    <Content className="m-3 desktop:m-4 desktop:mr-0">  { /* desktop:mr-0 is to prevent unwanted horizontal scrollbar */}
      <Breadcrumbs items={[{ title: 'Dashboard', icon: icons.Dashboard }]} />
      <div className="mr-4">
        <div className="grid grid-cols-1 xl:grid-cols-[auto_auto] grid-rows-[auto_1fr] gap-5 w-fit mx-auto">
          <div>
            <DashboardGame
              loading={loadingDashboard}
              game={dashboardData?.upcomingGame}
              title="Upcoming Game"
            />
          </div>
          <div>
            <DashboardGame
              loading={loadingDashboard}
              game={dashboardData?.recentGame}
              title="Recent Game"
              clickable={true}
            />
          </div>
          <div className="xl:row-span-full">
            <QuickLinks />
          </div>
        </div>
      </div>
    </Content>
  )
}

export default DashboardPlayer 